import { render, staticRenderFns } from "./CreateAppendixModal.vue?vue&type=template&id=57ec8476&"
import script from "./CreateAppendixModal.vue?vue&type=script&lang=js&"
export * from "./CreateAppendixModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports